import React from 'react';

export type ModuleKey =
    | 'attendance' | 'leave' | 'people' | 'holidays'
    | 'accounting' | 'inventory' | 'sales' | 'payroll' | 'expense'
    | 'merchandising'
    // T9: commercial (LC/B2B/EXP/UD/cash-incentive) joined the gated set in backend
    // DashboardModule (T1, 8 -> 9); this frontend copy was a backend-only commit and never
    // followed up, which meant useDashboardAccess's GATED_MODULE_KEYS filter would silently drop
    // "commercial" out of every enabledModules fetch (see moduleMeta.ts). Added here, not a merch
    // reconciliation.
    | 'commercial'
    // Maintenance (CMMS + utility logs) joined the gated set in backend DashboardModule.
    | 'maintenance'
    // Fixed assets is its own gated module (2026-10-20); journals still need accounting.
    | 'fixed_assets'
    // 2026-10-23: every sidebar menu has a module switch (mirrors backend DashboardModule).
    | 'shifts' | 'procurement' | 'tax' | 'insurance' | 'tasks' | 'notices' | 'reports'
    | 'help' | 'feedback' | 'xero';

export interface WidgetProps {
    institutionId: string;
}

/** Permission sentinel: no key gate, the widget shows only the caller's own data (module filter still applies). */
export const SELF_SERVICE = 'SELF_SERVICE';

export interface WidgetDef {
    id: string;
    module: ModuleKey;
    title: string;
    /** One-line grey caption under the title: what the widget shows, its period or scope. */
    subtitle?: string;
    permission: string;
    /**
     * Extra ways past the `permission` gate: the widget is also visible when the caller holds ALL
     * keys of any one group (e.g. HR: DASHBOARD_VIEW + ATTENDANCE_VIEW_ALL). Must mirror a server
     * guard the caller really passes.
     */
    alsoVisibleWith?: string[][];
    size: 'sm' | 'md' | 'lg';
    component: React.FC<WidgetProps>;
}
